import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import { ethers } from "ethers";
import _ from "lodash";
import QRReader from "./QRReader";
import {
  FromWei,
  PublishRawTx as PublishRawTxXdc,
  ToXdcAddress,
} from "../utilities/xdc3.js";
import { PublishRawTx as PublishRawTxWeb3 } from "../utilities/web3";
import Text from "../helpers/text";
import { DecodeData } from "../utilities/tokenInteraction";
import { ExplorerTx } from "../helpers/rpc";
import {
  GetBlockchainFromChainId,
  GetNonce,
  GetBalance,
  BlockchainType as BlockchainTypeObj,
  IsTestnetChainId,
  IsMainnetChainId,
} from "../utilities/address";
import { GetEquivalentSymbol } from "../utilities/symbols";
import Select from "react-select";
import {
  DecodeBitcoinRawTx,
  FromSats,
  PublishBitcoinRawTx,
} from "../utilities/bitcoin.js";
import { mainnetOptions, testnetOptions } from "../helpers/constant.js";
import {
  DecodeXrpRawTx,
  FromDrops,
  PublishXrpRawTx,
} from "../utilities/xrp.js";
import { DecodeSolanaRawTx, PublishSolanaRawTx } from "../utilities/solana.js";
import { useLocation } from "react-router-dom";

const processingStates = {
  initial: "Initial",
  pending: "Pending",
  completed: "Completed",
  failed: "Failed",
};

const btnMsg = {
  ready: "Publish",
  pending: "Submitting",
  completed: "Completed",
};

function RenderDecodedData({
  data,
  isValid,
  showForm,
  errorMessage = Text.RawTx.enterInput,
  errorClass = "info-msg",
}) {
  const chainType = GetBlockchainFromChainId(data.chainId);
  if (!showForm) {
    return (
      <>
        <Row>
          <Col className={`u-text-center ${errorClass}`}>{errorMessage}</Col>
        </Row>
      </>
    );
  }

  if (chainType === "bitcoin") {
    return (
      <>
        {!isValid && (
          <Row>
            <Col className={`u-text-center ${errorClass}`}>{errorMessage}</Col>
          </Row>
        )}
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Chain ID</label>
          </Col>
          <Col lg={9} sm={9}>
            <input disabled className="form-comtrol" value={data.chainId} />
          </Col>
        </Row>

        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Network</label>
          </Col>
          <Col lg={9} sm={9}>
            <input
              disabled
              className="form-comtrol text-capitalize"
              value={data.chainId === 3 ? "Bitcoin Testnet" : "Bitcoin Mainnet"}
            />
          </Col>
        </Row>

        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Transaction ID</label>
          </Col>
          <Col lg={9} sm={9}>
            <input
              disabled
              className="form-comtrol"
              value={data.txid || data.from}
            />
          </Col>
        </Row>

        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Value</label>
          </Col>
          <Col lg={9} sm={9} className="mb-3">
            <div className="appended-input">
              <input disabled className="form-comtrol" value={data.value} />
              <div className="appendage">sats</div>
            </div>
          </Col>
          <Col lg={3} sm={3}></Col>
          <Col lg={9} sm={9} className="mb-3">
            <div className="appended-input">
              <input disabled className="form-comtrol" value={data.eth} />
              <div className="appendage">BTC</div>
            </div>
          </Col>
        </Row>
      </>
    );
  }

  if (chainType === "xrp") {
    return (
      <>
        {!isValid && (
          <Row>
            <Col className={`u-text-center ${errorClass}`}>{errorMessage}</Col>
          </Row>
        )}
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Chain ID</label>
          </Col>
          <Col lg={9} sm={9}>
            <input disabled className="form-comtrol" value={data.chainId} />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Network</label>
          </Col>
          <Col lg={9} sm={9}>
            <input
              disabled
              className="form-comtrol text-capitalize"
              value={data.chainId === 142 ? "XRP Testnet" : "XRP Mainnet"}
            />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">From</label>
          </Col>
          <Col lg={9} sm={9}>
            <input disabled className="form-comtrol" value={data.from} />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">To</label>
          </Col>
          <Col lg={9} sm={9}>
            <input disabled className="form-comtrol" value={data.to} />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Value</label>
          </Col>
          <Col lg={9} sm={9}>
            <input disabled className="form-comtrol" value={data.value} />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">XRP</label>
          </Col>
          <Col lg={9} sm={9}>
            <input disabled className="form-comtrol" value={data.eth} />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Fee</label>
          </Col>
          <Col lg={9} sm={9}>
            <input disabled className="form-comtrol" value={data.gasPrice} />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Sequence</label>
          </Col>
          <Col lg={9} sm={9}>
            <input disabled className="form-comtrol" value={data.nonce} />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Balance</label>
          </Col>
          <Col lg={9} sm={9}>
            <input
              disabled
              className="form-comtrol"
              value={data.currentBalance}
            />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Balance (XRP)</label>
          </Col>
          <Col lg={9} sm={9}>
            <input
              disabled
              className="form-comtrol"
              value={data.currentBalanceEth}
            />
          </Col>
        </Row>
      </>
    );
  }

  if (chainType === "solana") {
    return (
      <>
        {!isValid && (
          <Row>
            <Col className={`u-text-center ${errorClass}`}>{errorMessage}</Col>
          </Row>
        )}
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Chain ID</label>
          </Col>
          <Col lg={9} sm={9}>
            <input disabled className="form-comtrol" value={data.chainId} />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">Network</label>
          </Col>
          <Col lg={9} sm={9}>
            <input
              disabled
              className="form-comtrol text-capitalize"
              value={data.chainId === 103 ? "Solana Testnet" : "Solana Mainnet"}
            />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">From</label>
          </Col>
          <Col lg={9} sm={9}>
            <input disabled className="form-comtrol" value={data.from} />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            <label className="form-comtrol">To</label>
          </Col>
          <Col lg={9} sm={9}>
            <input disabled className="form-comtrol" value={data.to} />
          </Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col lg={3} sm={3}>
            Raw Data
          </Col>
          <Col lg={9} sm={9}>
            <textarea disabled value={data.data} rows={10} />
          </Col>
        </Row>
      </>
    );
  }

  let decodedInput;
  if (data.data) {
    decodedInput = DecodeData(data.data);

    decodedInput = (
      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}></Col>
        <Col lg={9} sm={9}>
          {decodedInput}
        </Col>
      </Row>
    );
  }

  return (
    <>
      {!isValid ? (
        <>
          <Row>
            <Col className={`u-text-center ${errorClass}`}>{errorMessage}</Col>
          </Row>
        </>
      ) : (
        <></>
      )}
      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}>
          <label className="form-comtrol">Chain ID</label>
        </Col>
        <Col lg={9} sm={9}>
          <input disabled className="form-comtrol" value={data.chainId} />
        </Col>
      </Row>

      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}>
          <label className="form-comtrol">Network</label>
        </Col>
        <Col lg={9} sm={9}>
          <input
            disabled
            className="form-comtrol text-capitalize"
            value={
              IsTestnetChainId(data.chainId) ? `Apothem Testnet` : `XDC Mainnet`
            }
          />
        </Col>
      </Row>

      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}>
          <label className="form-comtrol">From Address</label>
        </Col>
        <Col lg={9} sm={9}>
          <input disabled className="form-comtrol" value={data.from} />
        </Col>
      </Row>

      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}>
          <label className="form-comtrol">To Address</label>
        </Col>
        <Col lg={9} sm={9}>
          <input disabled className="form-comtrol" value={data.to} />
        </Col>
      </Row>

      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}>
          <label className="form-comtrol">Value</label>
        </Col>
        <Col lg={9} sm={9} className="mb-3">
          <div className="appended-input">
            <input disabled className="form-comtrol" value={data.value} />
            <div className="appendage">
              {GetEquivalentSymbol(
                "wei",
                GetBlockchainFromChainId(data.chainId)
              )}
            </div>
          </div>
        </Col>
        <Col lg={3} sm={3}></Col>
        <Col lg={9} sm={9}>
          <div className="appended-input">
            <input disabled className="form-comtrol" value={data.eth} />
            <div className="appendage">
              {GetEquivalentSymbol(
                "ether",
                GetBlockchainFromChainId(data.chainId)
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}>
          <label className="form-comtrol">Nonce</label>
        </Col>
        <Col lg={9} sm={9}>
          <input disabled className="form-comtrol" value={data.nonce} />
        </Col>
      </Row>
      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}>
          <label className="form-comtrol">Current Nonce</label>
        </Col>
        <Col lg={9} sm={9}>
          <input disabled className="form-comtrol" value={data.currentNonce} />
        </Col>
      </Row>
      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}>
          <label className="form-comtrol">Balance</label>
        </Col>
        <Col lg={9} sm={9} className="mb-3">
          <div className="appended-input">
            <input
              disabled
              className="form-comtrol"
              value={data.currentBalance}
            />
            <div className="appendage">
              {GetEquivalentSymbol(
                "wei",
                GetBlockchainFromChainId(data.chainId)
              )}
            </div>
          </div>
        </Col>
        <Col lg={3} sm={3}></Col>
        <Col lg={9} sm={9}>
          <div className="appended-input">
            <input
              disabled
              className="form-comtrol"
              value={data.currentBalanceEth}
            />
            <div className="appendage">
              {GetEquivalentSymbol(
                "ether",
                GetBlockchainFromChainId(data.chainId)
              )}
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}>
          <label className="form-comtrol">{Text.RawTx.gasPrice}</label>
        </Col>
        <Col lg={9} sm={9}>
          <input disabled className="form-comtrol" value={data.gasPrice} />
        </Col>
      </Row>

      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}>
          <label className="form-comtrol">{Text.RawTx.gasLimit}</label>
        </Col>
        <Col lg={9} sm={9}>
          <input disabled className="form-comtrol" value={data.gasLimit} />
        </Col>
      </Row>

      <Row className="mb-2 align-items-center">
        <Col lg={3} sm={3}>
          <label className="form-comtrol">{Text.RawTx.data}</label>
        </Col>
        <Col lg={9} sm={9}>
          <div className="raw-tx-decoder--field">{data.data}</div>
        </Col>
      </Row>

      {decodedInput}
    </>
  );
}

function renderStatusNote(data) {
  if (data.processing !== true) {
    return <></>;
  }

  if (
    data.status === processingStates.pending ||
    data.status === processingStates.completed
  )
    return (
      <div className="highlighted-note">
        <div className="highlighted-note--title">Status</div>
        <div className="highlighted-note--body">
          <Container>
            <Row>
              <Col lg={4} md={4} sm={4} className="highlighted-note--body_key">
                Status
              </Col>

              <Col
                lg={8}
                md={8}
                sm={8}
                className="highlighted-note--body_field"
              >
                {data.status}
              </Col>
            </Row>
            <Row>
              <Col lg={4} md={4} sm={4} className="highlighted-note--body_key">
                TX Hash
              </Col>

              <Col
                lg={8}
                md={8}
                sm={8}
                className="highlighted-note--body_field"
              >
                {data.txHash}
              </Col>
            </Row>

            <Row>
              <Col lg={4} md={4} sm={4} className="highlighted-note--body_key">
                Link
              </Col>

              <Col
                lg={8}
                md={8}
                sm={8}
                className="highlighted-note--body_field"
              >
                <a href={data.link} rel="noreferrer" target="_blank">
                  {data.txHash.substr(0, 10)}...
                </a>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );

  if (data.status === processingStates.failed)
    return (
      <div className="highlighted-note">
        <div className="highlighted-note--title">Status</div>
        <div className="highlighted-note--body">
          <Container>
            <Row>
              <Col lg={4} md={4} sm={4} className="highlighted-note--body_key">
                Status
              </Col>

              <Col
                lg={8}
                md={8}
                sm={8}
                className="highlighted-note--body_field"
              >
                {data.status}
              </Col>
            </Row>
            <Row>
              <Col lg={4} md={4} sm={4} className="highlighted-note--body_key">
                Error
              </Col>

              <Col
                lg={8}
                md={8}
                sm={8}
                className="highlighted-note--body_field"
              >
                {data.errorMessage}
              </Col>
            </Row>
            <Row>
              <Col lg={4} md={4} sm={4} className="highlighted-note--body_key">
                TX Hash
              </Col>

              <Col
                lg={8}
                md={8}
                sm={8}
                className="highlighted-note--body_field"
              >
                {data.txHash}
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
}

function renderRedoBtn(data, cb) {
  if (
    true
    // (data.processing === true) &
    // [data.completed, data.failed].includes(data.status)
  ) {
    return (
      <button className="btn btn-outline-dark" onClick={() => cb()}>
        {Text.RawTx.reset}
      </button>
    );
  }

  return <></>;
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function RawTxDecoder() {
  const [rawTx, setRawTx] = useState("");
  const query = useQuery();
  const getNetwork = query.get("network");

  // Determine which options to use based on network parameter
  const getNetworkOptions = () => {
    if (getNetwork === "testnet") {
      return testnetOptions;
    } else {
      return mainnetOptions; // default to mainnet
    }
  };

  const networkOptions = getNetworkOptions();
  const [network, setNetwork] = useState(networkOptions[0]);
  // console.log("network", network);

  // console.log("getNetwork", getNetwork);
  /* console.log(
    "Using network options:",
    getNetwork === "testnet" ? "testnet" : "mainnet"
  ); */

  const [form, setForm] = useState({
    data: {},
    isValid: false,
    btnMsg: btnMsg.ready,
    processing: false,
    errorMessage: Text.RawTx.enterInput,
    status: "",
    txHash: "",
    showForm: false,
    currentBalance: "loading",
    errorClass: "info-msg",
  });

  const decodeSolanaRawTx = async () => {
    try {
      const decoded = await DecodeSolanaRawTx(rawTx, network.chainId); // Pass chainId for testnet support

      const from = decoded.message.accountKeys[0]; // usually signer
      const to = decoded.message.accountKeys.find((key, idx) => idx !== 0);

      setForm({
        ...form,
        data: {
          chainId: network.chainId, // Use selected network chainId
          from,
          to,
          value: "-",
          eth: "-",
          currentBalance: "-",
          currentBalanceEth: "-",
          nonce: "-",
          gasPrice: "-",
          gasLimit: "-",
          data: JSON.stringify(decoded, null, 2),
        },
        isValid: true,
        showForm: true,
      });
    } catch (e) {
      setForm({
        ...form,
        errorMessage: e.message,
        isValid: false,
        showForm: false,
        errorClass: "error-msg",
      });
    }
    return;
  };

  useEffect(() => {
    setNetwork(networkOptions[0]);
    setRawTx("");
    setForm({
      data: {},
      isValid: false,
      btnMsg: btnMsg.ready,
      processing: false,
      errorMessage: "Enter Input",
      status: "",
      txHash: "",
      showForm: false,
    });
  }, [networkOptions]);

  useEffect(() => {
    let isValid = false,
      showForm = false,
      errorMessage = Text.RawTx.enterInput,
      errorClass = "info-msg",
      data = {};

    if (!_.isEmpty(rawTx)) {
      const type = GetBlockchainFromChainId(network.chainId);

      if (type === BlockchainTypeObj.bitcoin) {
        try {
          const decoded = DecodeBitcoinRawTx(rawTx);
          data = {
            chainId: network.chainId, // Use selected network chainId (0 for mainnet, 3 for testnet)
            from: decoded.inputs[0]?.txid || "N/A",
            to: "Multiple", // BTC can have multiple outputs
            value: decoded.outputs[0]?.value || "0",
            eth: FromSats(decoded.outputs[0]?.value || "0"),
            nonce: "-",
            currentNonce: "-",
            gasPrice: "-",
            gasLimit: "-",
            data: "-",
          };

          GetBalance(data.from, type, network.chainId).then((balance) => {
            setForm({
              ...form,
              data: {
                ...data,
                currentBalance: balance,
                currentBalanceEth: FromSats(balance),
              },
              isValid: true,
              showForm: true,
            });
          });
        } catch (e) {
          errorMessage = e.message;
          errorClass = "error-msg";
          setForm({
            ...form,
            data,
            isValid: false,
            showForm: false,
            errorMessage,
            errorClass,
          });
        }
        return;
      }

      if (type === BlockchainTypeObj.xrp) {
        try {
          const decoded = DecodeXrpRawTx(rawTx);
          const from = decoded.Account;
          const to = decoded.Destination;
          const value = decoded.Amount;

          GetBalance(from, type, network.chainId).then((balance) => {
            setForm({
              ...form,
              data: {
                chainId: network.chainId, // Use selected network chainId
                from,
                to,
                value,
                eth: FromDrops(value),
                currentBalance: balance,
                currentBalanceEth: FromDrops(balance),
                nonce: decoded.Sequence,
                gasPrice: decoded.Fee,
                gasLimit: "-",
                data: "-",
              },
              isValid: true,
              showForm: true,
            });
          });
        } catch (e) {
          setForm({
            ...form,
            errorMessage: e.message,
            isValid: false,
            showForm: false,
            errorClass: "error-msg",
          });
        }
        return;
      }

      if (type === BlockchainTypeObj.solana) {
        decodeSolanaRawTx();
        return;
      }

      try {
        data = ethers.utils.parseTransaction(rawTx);
        data.gasPrice = data.gasPrice.toString();
        data.gasLimit = data.gasLimit.toString();
        data.value = data.value.toString();
        data.eth = FromWei(data.value);
        data.currentNonce = "loading";

        if (data.chainId != network.chainId) {
          setForm({
            ...form,
            isValid: false,
            showForm: false,
            errorMessage: `Invalid ${network.value} raw transaction`,
            errorClass: "error-msg",
          });
          return;
        }

        isValid = true;
        if (data.gasPrice == 0 || data.gasLimit == 0) {
          isValid = false;
          errorMessage = "invalid gas price / limit";
          errorClass = "error-msg";
        }
        showForm = true;
        let type = GetBlockchainFromChainId(data.chainId);

        if (type === BlockchainTypeObj.xinfin) {
          data.from = ToXdcAddress(data.from);
          data.to = ToXdcAddress(data.to);
        }

        GetNonce(data.from, type, data.chainId)
          .then((resp) => {
            const validNonce = data.nonce === resp;
            if (validNonce === false) {
              errorMessage = "invalid nonce";
              errorClass = "error-msg";
            }
            setForm({
              ...form,
              data: { ...data, currentNonce: resp },
              isValid: isValid && validNonce,
              showForm: true,
              errorMessage,
            });

            GetBalance(data.from, type, data.chainId)
              .then((bal) => {
                const validBalance = parseFloat(data.value) <= parseFloat(bal);
                if (validBalance === false) {
                  errorMessage = "invalid balance";
                  errorClass = "error-msg";
                }

                setForm({
                  ...form,
                  data: {
                    ...data,
                    currentNonce: resp,
                    currentBalance: bal,
                    currentBalanceEth: FromWei(bal),
                  },
                  isValid: isValid && validNonce && validBalance,
                  showForm: true,
                  errorMessage,
                  errorClass,
                });
              })
              .catch((e) => {
                errorMessage = "error while getting balance";
                errorClass = "error-msg";

                setForm({
                  ...form,
                  currentBalance: "error",
                  errorClass,
                  isValid: false,
                  errorMessage,
                });
              });
          })
          .catch((e) => {
            console.log("e", e);
            errorMessage = "error while getting nonce";
            errorClass = "error-msg";

            setForm({
              ...form,
              currentNonce: "error",
              isValid: false,
              errorMessage,
              errorClass,
            });
          });
      } catch (e) {
        console.error(e);
        data = {};
        isValid = false;
        showForm = false;
        errorMessage = Text.RawTx.inavlidData;
        errorClass = "error-msg";
      }
    }
    setForm({ ...form, data, isValid, showForm, errorMessage, errorClass });
  }, [rawTx, network]);

  const handlePublish = () => {
    setForm({
      ...form,
      processing: true,
      btnMsg: btnMsg.pending,
      state: processingStates.initial,
    });

    const type = GetBlockchainFromChainId(form.data.chainId);
    if (type === "bitcoin") {
      PublishBitcoinRawTx(rawTx, form.data.chainId)
        .then((txid) => {
          setForm({
            ...form,
            processing: true,
            status: processingStates.completed,
            btnMsg: btnMsg.completed,
            txHash: txid,
            link: `${ExplorerTx[form.data.chainId]}${txid}`,
          });
        })
        .catch((err) => {
          setForm({
            ...form,
            processing: true,
            status: processingStates.failed,
            errorMessage: err.message,
            btnMsg: btnMsg.completed,
          });
        });
      return;
    }

    if (type === "xrp") {
      PublishXrpRawTx(rawTx, form.data.chainId)
        .then((txid) => {
          setForm({
            ...form,
            processing: true,
            status: processingStates.completed,
            btnMsg: btnMsg.completed,
            txHash: txid,
            link: `${ExplorerTx[form.data.chainId]}${txid}`,
          });
        })
        .catch((err) => {
          setForm({
            ...form,
            processing: true,
            status: processingStates.failed,
            errorMessage: err.message,
            btnMsg: btnMsg.completed,
          });
        });
      return;
    }

    if (type === "solana") {
      PublishSolanaRawTx(rawTx, form.data.chainId)
        .then((txid) => {
          setForm({
            ...form,
            processing: true,
            status: processingStates.completed,
            btnMsg: btnMsg.completed,
            txHash: txid,
            link: `${ExplorerTx[form.data.chainId]}${txid}`,
          });
        })
        .catch((err) => {
          setForm({
            ...form,
            processing: true,
            status: processingStates.failed,
            errorMessage: err.message,
            btnMsg: btnMsg.completed,
          });
        });
      return;
    }

    const RawTxFunc = type === "xinfin" ? PublishRawTxXdc : PublishRawTxWeb3;

    RawTxFunc(rawTx, form.data.chainId)
      .once("transactionHash", function (hash) {
        setForm({
          ...form,
          processing: true,
          txHash: hash,
          status: processingStates.pending,
          link: `${ExplorerTx[`${form.data.chainId}`]}${hash}`,
        });
      })
      .once(
        "receipt",
        function (receipt) {
          if (receipt.status === true) {
            // tx succcess
            setForm({
              ...form,
              processing: true,
              status: processingStates.completed,
              btnMsg: btnMsg.completed,
              txHash: receipt.transactionHash,
              link: `${ExplorerTx[`${form.data.chainId}`]}${
                receipt.transactionHash
              }`,
            }).bind(this);
          } else {
            //tx failed
            setForm({
              ...form,
              processing: true,
              status: processingStates.failed,
              btnMsg: btnMsg.completed,
            }).bind(this);
          }
        }.bind(this)
      )
      .once("error", (err) => {
        setForm({
          ...form,
          processing: true,
          status: processingStates.failed,
          errorMessage: err.message,
          btnMsg: btnMsg.completed,
        });
      });
  };

  return (
    <Container>
      <div className="raw-tx-decoder">
        <Card className="custom-card-1 border-0">
          <Card.Body>
            <div className="title2">
              <div className="">Raw Transaction Decoder</div>
              <div
                className="text-muted"
                style={{ fontSize: "14px", marginTop: "5px" }}
              >
                Network: {getNetwork === "testnet" ? "Testnet" : "Mainnet"}
              </div>
            </div>

            <div className="custom-input-1">
              <div>
                <div className="select-container mb-3">
                  <label className="form-comtrol">
                    Select Blockchain Network
                  </label>
                  <Select
                    options={networkOptions}
                    onChange={(e) => {
                      setNetwork(
                        networkOptions.find((op) => op.chainId === e.chainId)
                      );
                      setForm({ ...form, chainId: e.chainId });
                      setRawTx("");
                    }}
                    value={network}
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderColor: "#B5D2DF",
                        boxShadow: "none",
                        "&:hover": { borderColor: "#B5D2DF" },
                        backgroundColor: "#E6F2FE",
                        cursor: "pointer",
                        fontSize: "13px",
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected
                          ? "#007bff"
                          : "#E6F2FE",
                        color: state.isSelected ? "#fff" : "#000",
                        "&:hover": {
                          backgroundColor: "#007bff",
                          color: "#fff",
                        },
                        cursor: "pointer",
                        fontSize: "13px",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: "black",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 999, // useful in modals
                        backgroundColor: "#E6F2FE",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        color: "#666",
                        "&:hover": {
                          color: "#333",
                        },
                      }),
                    }}
                  />
                </div>
                <div className="select-container mb-3">
                  <label className="form-comtrol">Enter Raw Transaction</label>
                  <textarea
                    disabled={form.processing}
                    className="form-comtrol"
                    onChange={(e) => setRawTx(e.target.value)}
                    placeholder={Text.RawTx.inputPlaceholder}
                    value={rawTx}
                  />
                </div>
                <div className="d-flex justify-content-end">
                  <QRReader onSubmit={(e) => setRawTx(e)} />
                </div>
              </div>

              <hr />
              {RenderDecodedData(form)}
              <hr />
            </div>

            <div className="card-actions">
              {renderRedoBtn({ ...form }, () => {
                setForm({
                  data: {},
                  isValid: false,
                  btnMsg: btnMsg.ready,
                  processing: false,
                  errorMessage: "Enter Input",
                  status: "",
                  txHash: "",
                  showForm: false,
                });
                setNetwork(networkOptions[0]);
                setRawTx("");
              })}
              <button
                className="btn btn-dark ml-3"
                disabled={
                  form.isValid === false || form.btnMsg !== btnMsg.ready
                }
                onClick={() => handlePublish()}
              >
                {form.btnMsg}
              </button>
            </div>

            <Row>
              <Col>{renderStatusNote({ ...form })}</Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
}
